// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Moldova */
const MD = /^(?:562\d{5}|(?:6\d|7[16-9])\d{6})$/;

export default MD;
